import { Link, NavLink, useParams } from "react-router-dom";

export function AdminPartnersNav({ active = "list" }) {
  const items = [
    { key: "list", label: "Aliados", href: "/admin/partners" },
    { key: "categories", label: "Categorías", href: "/admin/partners/categories" },
    { key: "routing", label: "Routing", href: "/admin/partners/routing" },
    { key: "disclosures", label: "Divulgaciones", href: "/admin/partners/disclosures" },
    { key: "analytics", label: "Analytics", href: "/admin/analytics/partners" },
  ];
  return (
    <nav className="admin-console__nav-tabs">
      {items.map((item) => (
        <NavLink key={item.key} to={item.href} end={item.key === "list"} className={({ isActive }) => (isActive || active === item.key ? "is-active" : undefined)}>
          {item.label}
        </NavLink>
      ))}
      <Link to="/admin/leads?tab=partner">Leads aliados</Link>
      <Link to="/admin/playbook/partnerships">Playbook</Link>
    </nav>
  );
}

export function AdminPartnerDetailNav({ partnerId, active = "detail" }) {
  const base = `/admin/partners/${partnerId}`;
  const items = [
    { key: "detail", label: "Perfil", href: base },
    { key: "leads", label: "Leads", href: `${base}/leads` },
    { key: "performance", label: "Performance", href: `${base}/performance` },
  ];
  return (
    <nav className="admin-console__nav-tabs">
      {items.map((item) => (
        <NavLink key={item.key} to={item.href} end={item.key === "detail"} className={({ isActive }) => (isActive || active === item.key ? "is-active" : undefined)}>
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}

export function usePartnerIdParam() {
  return useParams().partnerId;
}
